const GOOGLE_OAUTH = {
  CLIENT_ID: '570269009194-h7671hghsjngnnk548etu6f45rj4li41.apps.googleusercontent.com',
};

module.exports = { GOOGLE_OAUTH };
